import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=6c64a2ec&scoped=true&"
import script from "./Surveys.vue?vue&type=script&lang=ts&"
export * from "./Surveys.vue?vue&type=script&lang=ts&"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=6c64a2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64a2ec",
  null
  
)

export default component.exports